/**
 * Normaliza e limpa a URL removendo query parameters e hashes
 * para conformidade com a LGPD/GDPR e agrupamento correto de métricas.
 */
export function cleanUrl(value: string): string {
  if (!value) return '';
  try {
    const url = new URL(value, window.location.origin);
    return url.origin + url.pathname;
  } catch {
    return '';
  }
}
